export default __webpack_public_path__ + "static/media/punctuation.37e40b4d.svg";